export default {
  // url: '/washingmanage'
  // url: 'http://api.chebaotec.com/washingmanage'
  url: 'https://www.pwstec.com/washingmanage'
}



// WEBPACK FOOTER //
// ./src/config/common.js